package one.healthium.paywall.ui.components

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.IntrinsicSize
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import androidx.compose.ui.util.fastFirstOrNull
import androidx.compose.ui.util.fastForEach
import one.healthium.domain.paywall.models.ProductControl
import one.healthium.paywall.ui.models.ProductUiModel
import one.healthium.ui.common.utils.toAlignmentHorizontal
import one.healthium.ui.common.utils.toColor
import one.healthium.ui.compose.theme.AppTheme

@Composable
fun PlansControlsView(
    modifier: Modifier = Modifier,
    controls: List<ProductControl>,
    products: List<ProductUiModel>,
    onClick: (ProductControl) -> Unit,
    selectedProductId: String? = null,
    minHeight: Dp? = null,
) {
    Column(
        modifier = modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(4.dp)
    ) {
        controls.fastForEach { control ->
            val product = remember(control.product, products) {
                products.fastFirstOrNull { it.id == control.product }
            }
            if (product != null) {
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .background(
                            color = control.backgroundColor?.toColor() ?: Color.Transparent,
                            shape = AppTheme.shapes.small,
                        )
                        .clip(AppTheme.shapes.small)
                        .then(
                            if (selectedProductId == product.id) {
                                Modifier.border(
                                    width = 2.dp,
                                    color = control.selectedBorderColor?.toColor() ?: Color.Transparent,
                                    shape = AppTheme.shapes.small,
                                )
                            } else {
                                Modifier
                            }
                        )
                        .height(IntrinsicSize.Max)
                        .heightIn(min = minHeight ?: Dp.Unspecified)
                        .clickable {
                            onClick(control)
                        }
                ) {
                    control.columns.fastForEach { columnModel ->
                        val weight = columnModel.weight
                        Column(
                            modifier = Modifier
                                .fillMaxHeight()
                                .then(
                                    if (weight != null && weight > 0) {
                                        Modifier.weight(weight.toFloat())
                                    } else {
                                        Modifier
                                    }
                                ),
                            verticalArrangement = Arrangement.Center,
                            horizontalAlignment = columnModel.alignment.toAlignmentHorizontal() ?: Alignment.Start,
                        ) {
                            Spacer(Modifier.weight(1f))
                            columnModel.lines.fastForEach { lineModel ->
                                AttributedLine(lineModel = lineModel, product = product)
                            }
                            Spacer(Modifier.weight(1f))
                        }
                    }
                }
            }
        }
    }
}
